import { UserCredentials, useSettings } from '@capsicum/common';
import { Menu, useRouter } from '@capsicum/common-web';
import { DotdotdotVerticalIcon } from '@capsicum/common-web/icons';
import { useDottedMenu } from '@capsicum/features/wallet/shared';
import { RequirementsPageCredentialsNeeded } from '@capsicum/socios-core';
import { useCredentialsHandler } from '@capsicum/socios-core-web';
import { useTheme } from 'styled-components';

/** This component is the "DottedMenu" for the "topBarHeaderRight" prop of  PageContainer.
 * @param None
 * @returns {JSX.Element} This component
 */
export const DottedMenu = () => {
	const router = useRouter();
	const { colors } = useTheme();
	const { settings } = useSettings();
	const { intlText } = useDottedMenu();

	const { handleCredential: onRedeemVoucher } = useCredentialsHandler({
		credentialCodes: UserCredentials.VOTE_TOKEN_REDEEM,
		onCredentialGranted: () => router.push('/wallet/voucher'),
		page: RequirementsPageCredentialsNeeded.voucherRedemption
	});

	const menuProps = {
		children: <DotdotdotVerticalIcon color={colors.text.main.enabled} />,
		items: [
			...(!settings?.isPoblanoEnabled
				? [
						{
							onClick: () => router.push('/wallet/transactions?tab=currency'),
							testID: 'mainWallet-homePage-dottedMenu-transaction',
							title: intlText.transactionHistory
						}
					]
				: [])
		],
		testID: 'mainWallet-homePage-dottedMenu-button'
	};

	if (settings?.isVoucherEnabled) {
		menuProps.items.push({
			onClick: onRedeemVoucher,
			testID: 'mainWallet-homePage-dottedMenu-voucher',
			title: intlText.redeemVoucher
		});
	}

	if (menuProps.items.length === 0) return null;

	return <Menu key="mainWallet-homePage-dottedMenu" {...menuProps} />;
};
